<div class="cartaoDependente">
  <div class="lista-cartao-dependente" *ngFor="let dependent of dependents">
    <div>
      <section class="example-section">
        <mat-slide-toggle *ngIf="dependent.Status.Id !== 3" class="example-margin" [(ngModel)]="dependent.Status.Id"
          (change)="setIsActive($event, dependent)">
          <h2>Cartão Ativo</h2>
        </mat-slide-toggle>
        <h2 *ngIf="dependent.Status.Id === 3">Aguardando segunda via</h2>
      </section>
      <section class="example-section-company">
        <h2>{{ dependent.NomeDoLocal }}</h2>
      </section>
      <div id='payment' class='payment'>
        <div
          [ngClass]="{'card' : dependent.Status.Id > 0 && dependent.Status.Id < 3, 'card-disabled' : dependent.Status.Id == 0 || dependent.Status.Id === 3}"
          [routerLink]="dependent.LinkMaisInformacoes">
          <div class='card-content'>
            <img class="logo-cartao" src="assets/images/logo-cartao.png" width="80">
            <div>
              <h5>
                {{
                dependent.NomeTitular && dependent.NomeTitular.length > 18
                ? dependent.NomeTitular.substr(0,16) + '...'
                : dependent.NomeTitular
                }}
              </h5>
              <h6 id='label-cardnumber'>
                {{
                dependent.Numero.length > 18
                ? dependent.Numero.substr(0,16) + '...'
                : dependent.Numero
                }}
              </h6>
            </div>
            <div class="side-informations-left" *ngIf="dependent.EhNominal && dependent.Apelido">
              <h5>Apelido</h5>
              <h6 id='label-cardnumber'>
                {{
                dependent.Apelido.length > 18
                ? dependent.Apelido.substr(0,16) + '...'
                : dependent.Apelido
                }}
              </h6>
            </div>
            <div [ngClass]="{'side-informations-right': dependent.Apelido}" class="side-informations-right" *ngIf="dependent.EhNominal">
              <h5>Senha</h5>
              <h6 id='label-cardnumber'>{{ dependent.Senha }}</h6>
            </div>
          </div>
          <div class='wave'></div>
        </div>
      </div>
      <div class="list-menu">
        <ul>
          <li *ngIf="dependent.Status.Id === 3" style="border-bottom: 0;"
            routerLink="/general/segundaVia/{{ dependent.Tag }}">
            <h2>
              Associar segunda via
            </h2>
            <i class="icon-right-open-big"></i>
          </li>
          <li [routerLink]="dependent.LinkMaisInformacoes">
            <h2>
              Configurações do Cartão
            </h2>
            <i class="icon-right-open-big"></i>
          </li>
          <br>
          <br>
        </ul>
      </div>
    </div>
  </div>

  <button routerLink="/general/registrarDependente" class="confirma">
    Cadastrar cartão Meep
  </button>
  <div class="backgroundTrasparente"></div>

</div>


// WEBPACK FOOTER //
// /usr/src/app/src/app/components/dependent-card/dependent-card.component.html